import { Module } from 'wrapper6'
import 'url-search-params-polyfill'

const $ = jQuery

export default class ArchiveProduct extends Module {
  ready (app) {
    this.wrapper = document.querySelector('.mtt-product-archive')
    this.queryWrapper = document.querySelector('.mtt-product-archive__loop-products')
    this.loader = document.querySelector('#loader')
    this.searchInput = document.querySelector('#product-search')

    this.addSearch()
    this.onListShowingClick()
  }

  addSearch () {
    if (this.searchInput) {
      let timeout = null
      this.searchInput.addEventListener('input', (e) => {
        e.preventDefault()

        if (timeout) {
          clearTimeout(timeout)
        }

        timeout = setTimeout(() => {
          this.showProductsFromAjax()
        }, 500)
      })
    }
  }

  onListShowingClick () {
    const btns = document.querySelectorAll('.mtt-product-archive__loop-list')

    if (btns.length) {
      for (let i = 0; i < btns.length; i++) {
        const btn = btns[i]

        btn.addEventListener('click', () => {
          this.btn = btn

          this.changeActiveBtn()
          this.showProductsFromAjax()
        })
      }
    }
  }

  showProductsFromAjax () {
    this.showLoader()

    const data = {
      action: 'getProductsShowing',
      currentTerm: this.wrapper.querySelector('[data-term]').getAttribute('data-term'),
      listOption: this.wrapper.querySelector('.mtt-product-archive__loop-list.active').getAttribute('data-list'),
      s: this.searchInput.value
    }

    $.post(main_theme_objects.ajax_url, data, (response) => {
      if (response.markup !== '') {
        this.queryWrapper.innerHTML = response.markup
      } else {
        this.queryWrapper.innerHTML = '<div class="no-posts"> Sorry, no posts matched your criterias </div>'
      }

      document.querySelector('.post-count').innerHTML = response.postcount

      this.removeLoader()
    })
  }

  changeActiveBtn () {
    document.querySelector('.mtt-product-archive__loop-list.active').classList.remove('active')
    this.btn.classList.add('active')
  }

  showLoader () {
    this.loader.classList.add('show')
  }

  removeLoader () {
    this.loader.classList.remove('show')
  }
}
